import { generateLogger, Level } from '@moda/portal-logger';
import { CONFIG } from './config';

export const logger = generateLogger(CONFIG.LOG_LEVEL as Level);
